import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://167.71.62.249/';

const apiClient = axios.create({ baseURL: BASE_URL });

let refreshPromise = null;

const refreshAccessToken = () => {
    const currentUser = JSON.parse(localStorage.getItem('user'));
    if (!currentUser || !currentUser.refresh) {
        return Promise.reject(new Error('No refresh token available'));
    }

    return axios.post(BASE_URL + 'auth/token/refresh/', { refresh: currentUser.refresh })
        .then(response => {
            const updatedUser = {
                ...currentUser,
                access: response.data.access,
                refresh: response.data.refresh,
            };
            localStorage.setItem('user', JSON.stringify(updatedUser));
            return updatedUser;
        });
};

apiClient.interceptors.request.use(config => {
    const currentUser = JSON.parse(localStorage.getItem('user'));
    if (currentUser && currentUser.access) {
        config.headers.Authorization = `Bearer ${currentUser.access}`;
    }
    return config;
});

apiClient.interceptors.response.use(
    response => response,
    error => {
        const { config, response } = error;

        if (!response || response.status !== 401 || config._retry) {
            return Promise.reject(error);
        }
        config._retry = true;

        if (!refreshPromise) {
            refreshPromise = refreshAccessToken().finally(() => {
                refreshPromise = null;
            });
        }

        return refreshPromise
            .then(updatedUser => {
                config.headers.Authorization = `Bearer ${updatedUser.access}`;
                return apiClient(config);
            })
            .catch(refreshError => {
                localStorage.removeItem('user');
                window.location.href = '#/login';
                return Promise.reject(refreshError);
            });
    }
);

export default apiClient;
